define([
  "marionette",
  "messaging/messenger",
  "./snippetListView",
  "./snippetsControls/snippetsControlsModule",
  "modules/shared/sortableList/sortableListModule",
  "modules/topicsSplit/snippet/snippetModel",
], function (Marionette, Messenger, SnippetListView, SnippetsControlsModule, SortableListModule) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "snippetList";
      this.region = options.region;
      this.rootSnippetGroup = options.rootSnippetGroup;
      this._setUpVents();
    },
    show: function (groupModel) {
      const headers = Messenger.reqres.request("snippet:list:headers");
      this.group = groupModel;
      this.layout = new SnippetListView.snippetListLayout();
      this.controls = this.addSubModule(
        new SnippetsControlsModule({
          region: this.layout.controls,
        }),
      );
      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: this.name,
        }),
      );
      this.layout.on("show", () => {
        this._showSubViews(groupModel);
      });
      this.showRegion(this.layout);
    },
    _showSubViews: function (groupModel) {
      this.controls.show(groupModel, this.rootSnippetGroup);
      this.list.show(groupModel.snippets());
    },
    _setUpVents: function () {
      //selected a snippet from the sortable list
      Messenger.vent.on(
        "snippetList:selected:row",
        (model) => {
          Messenger.vent.trigger("show:snippet:edit:page", model);
        },
        this,
      );
    },
  });
});
